import AuthOnboardingShell from './AuthOnboardingShell';

export { AuthOnboardingShell };
